import { Inject, NgModule } from '@angular/core';

import { MENU_COUNTERS_PROVIDER, MenuCountersProvider, MenuCountersService } from '@frontend/vanilla/core';

import { SharedModule } from '../shared/shared.module';
import { NativeBridgeAdapter } from './services/NativeBridgeAdapter/nativebridge.adapter';
import { NativeBridgeBootstrapperService } from './services/NativeBridgeBootstrapper/native-bridge-bootstrapper.service';
import { PortalNativeEventNotifier } from './services/PortalNativeEventNotifier/portal-nativeEvent-notifier';
import { VanillaAuthService } from './services/vanillaAuth/vanilla-auth.service';
import { VanillaDynamicComponentLoaderService } from './services/vanillaComponentDynamicLoader/vanilla-dynamic-component-loader.service';
import { VanillaEventsService } from './services/vanillaEventsService/vanilla-events.service';
import { VanillaSmartBannerHandlerService } from './services/vanillaSmartBannerHandler/vanilla-smart-banner-handler.service';

@NgModule({
    imports: [SharedModule],
    providers: [NativeBridgeAdapter, PortalNativeEventNotifier, NativeBridgeBootstrapperService],
})
export class VanillaInitModule {
    constructor(
        private vanillaDynamicComponentLoaderService: VanillaDynamicComponentLoaderService,
        private vanillaAuthService: VanillaAuthService,
        private vanillaSmartBannerHandlerService: VanillaSmartBannerHandlerService,
        private menuCountersService: MenuCountersService,
        private vanillaEventsService: VanillaEventsService,
        @Inject(MENU_COUNTERS_PROVIDER) private providers: MenuCountersProvider[],
    ) {
        this.vanillaAuthService.init();
        this.vanillaDynamicComponentLoaderService.init();
        this.vanillaSmartBannerHandlerService.init();
        this.menuCountersService.registerProviders(this.providers);
        this.vanillaEventsService.init();
    }
}
